export const toB64 = (x, from = 'binary') => Buffer.from(x, from).toString('base64');
export const fromB64 = (x, to = 'binary') => Buffer.from(x, 'base64').toString(to);
